// extracted by mini-css-extract-plugin
export default {"languageSelector":"LanguageSelector_languageSelector__zECHY","element":"LanguageSelector_element__Yjtnj","flag":"LanguageSelector_flag__2KVOK"};